<template>
  <v-card>
    <v-toolbar dark color="primary" tabs>
      <v-btn icon dark @click="closeForm()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('Información del trabajador/a') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn v-if="!disabled" dark flat @click="submit">
          {{ $t('Enviar') }}
        </v-btn>
        <v-btn v-if="disabled" dark flat @click="closeForm()">
          {{ $t('Cerrar') }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div>
      <v-form>
        <v-card class="worker-details-form">
          <div class="worker-details-form__group">
            <v-card-text>
              <worker-admin-data
                :disabled="disabled"
                :admin-view="adminView"
                v-model="formData"
              ></worker-admin-data>
              <datos-trabajador :disabled="disabled" v-model="formData"></datos-trabajador>
              <datos-contrato
                :disabled="disabled"
                :admin-view="adminView"
                v-model="formData"
              ></datos-contrato>
            </v-card-text>
          </div>
          <v-card-actions>
            <v-btn @click="closeForm()">
              {{ $t('Cancelar') }}
            </v-btn>

            <v-spacer></v-spacer>
            <v-btn v-if="!disabled" @click="submit()">
              {{ $t('Enviar') }}
            </v-btn>
            <v-btn v-if="disabled" @click="closeForm()">
              {{ $t('Cerrar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </div>
  </v-card>
</template>

<script>
import DatosTrabajador from '../laboral-requests/partials/DatosTrabajador.vue';
import DatosContrato from './partials/DatosContrato.vue';
import WorkerAdminData from './partials/WorkerAdminData.vue';

const moment = require('moment');

export default {
  components: {
    DatosTrabajador,
    DatosContrato,
    WorkerAdminData,
  },
  props: {
    editForm: {
      type: Boolean,
      default: false,
    },
    codempre: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    adminView: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          fullname: null,
          nif: null,
          num_ss: null,
          birthdate: null,
          address: null,
          city: null,
          province: null,
          cp: null,
          nationality: null,
          phone: null,
          email: null,
          F_ALTA: null,
          F_BAJA: null,
          F_ANTIG: null,

          CODEMPRE: null,
          CODTRAB: null,
          OBSERVACIONES: null,
          DISCAPACIDAD: null,
          IMPUESTO: null,
          TIPO_IRPF: null,
          CLAVE_IRPF: null,
          PUESTO: null,
          F_CONTR: null,
          F_HASTA_CONTR: null,
          HORAS_DIA: null,
          HORAS_SEM: null,
          REGIMEN: null,
          BRUTO: null,
          TITUL_ACADEMICA: null,
          NUM_AFILIACION_SUSTITUIDO: null,
          CAUSA_SUSTITUCION: null,
        };
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    requestType() {
      return this.formData.type;
    },
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.$vuetify.goTo(0);
    // this.setMockData();
  },
  methods: {
    setMockData() {
      this.formData = {
        type: 'alta_trabajador',

        request_data: {
          tipo_de_contrato: 'sustitucion',
          obra_y_servicio: {},
          eventual: {},
          sustitucion: {
            nationality: 'Sofía Luque González',
            sustitucion_motivo: 'Baja Maternal',
            sustitucion_fecha_fin: '2021-09-30',
          },
          titulacion: 'Licenciado',
          categoria_profesional: 'Profesor',
          jornada_laboral: 'parcial',
          jornada_laboral_horas_semanales: '25',
          jornada_laboral_horario: '9:00 a 14:00 de Lunes a Viernes',
          remuneracion_bruta: 'pactada',
          remuneracion_bruta_cantidad: '30000',
          numero_de_pagas: '12',
        },
        worker_data: {
          fullname: 'Alberto Guerrero García de Arboleya',
          nif: '09189142K',
          num_ss: null,
          birthdate: '1984-02-27',
          address: 'Paseo de los rosales, 19',
          city: 'Merida',
          province: 'Badajoz',
          cp: '06800',
          nationality: 'España',
          phone: '669942874',
          email: 'albertoguerrerogarcia@gmail.com',
        },
        comments: 'Ninguna',
      };
    },
    submit() {
      this.addExtraFields();
      const validate = this.validateForm();

      if (validate) {
        this.$emit('submit', this.formData);
      }
    },
    addExtraFields() {
      if (!this.formData.date) {
        this.formData.date = moment().format('YYYY-MM-DD');
      }

      if (!this.formData.status) {
        this.formData.status = 'opened';
      }

      if (this.codempre) {
        this.formData.codempre = this.codempre;
      }
    },
    validateForm() {
      return true;
    },
    closeForm() {
      console.log('Close form');
      this.$emit('close-form');
    },
  },
};
</script>

<style lang="sass"></style>
